






















import GroupLayerSimplified from '@/components/layers/GroupLayerSimplified.vue';
import SingleLayerElementSimplified from '@/components/layers/SingleLayerElementSimplified.vue';
import AbstractLayerTreeElement from '@/models/map-context/AbstractLayerTreeElement';
import LayerConfig from '@/models/map-context/LayerConfig';
import LayerGroupConfig from '@/models/map-context/LayerGroupConfig';
import Component from 'vue-class-component';
import PluginComponent from '../plugins/PluginComponent';

@Component({
  props: {},
  components: {
    GroupLayerSimplified,
    SingleLayerElementSimplified,
  },
})
export default class FiltrePlugin extends PluginComponent {
  static ID = 'FiltrePlugin';

  showAddLayerBtn = true;

  isDragging = false;

  modalLeft = 0;

  modalTop = 120;

  startX = 0;
  startY = 0;

  tempModalLeft:any;
  tempModalTop:any;

  mapId= 'mapcontainer';

  collapsed=false;

  title='Couches de données';

  created() {
    console.log(this.contextService.currentContext);
  }
  
  toggle(){
    this.collapsed = !this.collapsed;
  }

  mounted() {
    if(this.plugin.getParameterValue('title') && this.plugin.getParameterValue('title').length>0){
      this.title = this.plugin.getParameterValue('title');
    }

    this.showAddLayerBtn = this.contextService.configuration.addLayers !== undefined;
    this.showAddLayerBtn =
      this.showAddLayerBtn && this.plugin && this.plugin.getParameterValue('showAddLayerBtn');
    document.addEventListener('mousemove', this.dragModal);
    document.addEventListener('mouseup', this.stopDragging);
  }

  getLayersAndGroups() {
    return this.contextService.getCurrentContext().layers;
  }

  addLayer() {
    this.contextService.setCurrentAction('addLayer', {});
  }

  startDragging(event: MouseEvent) {

    this.startX=event.clientX;
    this.startY=event.clientY;
    this.tempModalLeft=this.modalLeft;
    this.tempModalTop=this.modalTop;
    this.isDragging = true;
    
  }

  stopDragging() {
    this.isDragging = false;
  }

  beforeDestroy():void {
    document.removeEventListener('mousemove', this.dragModal);
    document.removeEventListener('mouseup', this.stopDragging);
  }

  getCustomStyle() { 
    return `left:${this.modalLeft}px;top:${this.modalTop}px`;
  }

  dragModal(event: MouseEvent) {
    if (this.isDragging) {
      
      let varX=event.clientX -this.startX;
      let varY=event.clientY -this.startY;
      // Calcul de la nouvelle position en fonction de la position initiale et du deplacement de la souris depuis le debut du drag
      this.modalLeft = this.tempModalLeft + varX;
      this.modalTop = this.tempModalTop + varY;

    }
  }

  addGroupLayerElement() {
    this.contextService
      .getCurrentContext()
      .getLayers()
      .unshift(
        new LayerGroupConfig({
          title: 'Nouveau Groupe',
          childs: [],
        })
      );
  }

  addVectorLayer() {
    const newLayer: LayerConfig = new LayerConfig({
      title: 'Nouveau Dessin',
      type: 'Vector',
      visible: true,
      editable: true,
      layerProperties: [],
      boundingBoxEPSG4326: [-180, -90, 180, 90],
    });

    console.log(newLayer);

    try {
      this.contextService.getCurrentContext().getLayers().unshift(newLayer);
      this.getMapService().addLayer(newLayer);
    } catch (error: any) {
      newLayer.addError(error);
      console.log(error);
    }
  }
}
